import { useState } from "react";
import { Form, Input, Button, Upload, message, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import { submitQuestionnaire } from "../../api/questionnaire";
import { uploadToCOS, deleteFromCOS } from "../../utils/cosUpload";
import "./index.less";

const { Option } = Select;

const QuestionnaireSurvey = (props) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [gradeOther, setGradeOther] = useState(false); // 是否选择了"其他"
  const { meta = {}, location } = props;
  // type 字段 媒体是2 内部是1
  const sourceType =
    meta?.type || (location?.pathname?.includes("/questionnaire/media") ? 2 : location?.pathname?.includes("/questionnaire/u") ? 3 : 1);

  // 文件上传前的验证
  const beforeUpload = (file) => {
    const isLt30M = file.size / 1024 / 1024 < 30;
    if (!isLt30M) {
      message.error("单个文件大小不能超过30MB!");
      return Upload.LIST_IGNORE;
    }
    if (fileList.length >= 10) {
      message.error("最多只能上传10个文件!");
      return Upload.LIST_IGNORE;
    }
    // 阻止自动上传，手动控制上传时机
    return false;
  };

  // 处理文件变化，文件选择后立即上传
  const handleFileChange = async ({ fileList: newFileList }) => {
    // 判断是删除操作还是添加操作
    const isRemoving = newFileList.length < fileList.length;
    
    // 如果是删除操作，直接更新列表，不触发上传
    if (isRemoving) {
      setFileList(newFileList);
      return;
    }
    
    // 获取当前文件列表的 UID 集合
    const currentUids = new Set(fileList.map(f => f.uid));
    
    // 找出新添加的文件（在新列表中但不在当前列表中，且有 originFileObj，且没有上传过）
    const newFiles = newFileList.filter(
      item => !currentUids.has(item.uid) && item.originFileObj && !item.cosKey && !item.cosUrl
    );
    
    // 先更新文件列表（显示新添加的文件），确保文件名正确保留
    const updatedFileList = newFileList.map(file => {
      // 确保文件名存在，优先使用 file.name，其次使用 originFileObj.name
      if (!file.name && file.originFileObj) {
        return {
          ...file,
          name: file.originFileObj.name,
        };
      }
      return file;
    });
    setFileList(updatedFileList);
    
    // 对新添加的文件立即上传
    if (newFiles.length > 0) {
      newFiles.forEach(async (newFile) => {
        // 保存原始文件名
        const originalFileName = newFile.name || newFile.originFileObj?.name;
        
        // 标记为上传中
        setFileList(prevList => 
          prevList.map(item => 
            item.uid === newFile.uid 
              ? { ...item, name: originalFileName || item.name, status: 'uploading' }
              : item
          )
        );
        
        try {
          // 立即上传到COS
          const result = await uploadToCOS(newFile.originFileObj, 'town_introduction/questionnaire');
          
          if (result.success) {
            // 更新文件列表，保存上传后的信息
            setFileList(prevList => 
              prevList.map(item => {
                if (item.uid === newFile.uid) {
                  // 确保文件名始终存在，优先使用当前列表中的文件名
                  const fileName = item.name || originalFileName || newFile.originFileObj?.name || '未知文件';
                  return {
                    ...item,
                    name: fileName, // 确保文件名存在
                    status: 'done',
                    url: result.url,
                    cosKey: result.key, // 保存key用于删除
                    cosUrl: result.url, // 保存URL用于提交
                  };
                }
                return item;
              })
            );
            message.success(`${originalFileName || '文件'} 上传成功`);
          }
        } catch (error) {
          // 上传失败，更新状态
          setFileList(prevList => 
            prevList.map(item => {
              if (item.uid === newFile.uid) {
                return {
                  ...item,
                  name: newFile.name, // 保留原始文件名
                  status: 'error',
                };
              }
              return item;
            })
          );
          message.error(`${newFile.name} 上传失败: ${error.message}`);
        }
      });
    }
  };

  // 删除文件（同时删除COS中的文件）
  const handleRemove = async (file) => {
    // 如果文件已上传到COS，先删除COS中的文件
    if (file.cosKey) {
      try {
        await deleteFromCOS(file.cosKey);
        message.success(`${file.name} 已删除`);
      } catch (error) {
        console.error('删除COS文件失败:', error);
        message.error(`删除文件 ${file.name} 失败，请重试`);
        return false; // 删除失败，不删除列表中的文件
      }
    }
    
    // 返回 true 允许删除，onChange 会自动更新列表
    return true;
  };

  // 提交表单
  const onFinish = async (values) => {
    try {
      // 检查是否有文件
      if (fileList.length === 0) {
        message.error("请至少上传一个附件");
        return;
      }

      // 检查是否有未上传成功的文件
      const failedFiles = fileList.filter(file => file.status === 'error' || !file.cosUrl);
      if (failedFiles.length > 0) {
        message.error("存在未上传成功的文件，请重新上传或删除后重试");
        return;
      }

      setUploading(true);

      // 提交表单数据（包含文件信息）
      
      // 获取已上传文件的URL列表
      const uploadedFiles = fileList
        .filter(file => file.cosUrl && file.status === 'done')
        .map(file => file.cosUrl);
      
      const submitData = {
        ...values,
        // 用于区分媒体填报和内部填报的来源标识 1 内部，2 媒体
        source: sourceType,
        // 文件URL列表（逗号分隔）
        attachment: uploadedFiles.join(",")
      };
      console.log(submitData,'--submitData');
      

      const result = await submitQuestionnaire(submitData);
      
      if (result.code === 200) {
        message.success("提交成功！");
        form.resetFields();
        setFileList([]);
      } else {
        message.error(result.msg || "提交失败，请重试");
      }
    } catch (error) {
      console.error("提交错误:", error);
      message.destroy('uploading');
      
      // 如果是 302 重定向错误，提示更明确的信息
      if (error.response && error.response.status === 302) {
        message.error("接口路径不正确，请检查后端接口地址");
      } else {
        message.error(error.message || "提交失败，请重试");
      }
    } finally {
      setUploading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("表单验证失败:", errorInfo);
  };

  return (
    <div className="questionnaire-survey">
      <div className="survey-container">
        <div className="survey-header">
          <h1 className="survey-title">
            "AI + 金融"创新实验室——"AI + 量化"特训营暨“阿尔法杯”精英赛报名问卷
          </h1>
          <p className="survey-intro">
            欢迎报名“AI + 金融”创新实验室——“AI + 量化”特训营暨“阿尔法杯”精英赛！请认真填写以下信息，这将作为我们综合评估与后续沟通的重要依据。您所填报的信息仅用于内部评审，我们将保障您的信息安全与隐私。          </p>
        </div>

        <Form
          form={form}
          name="questionnaire"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className="survey-form"
        >
          <Form.Item
            label={<span className="required-label">您的姓名</span>}
            name="name"
            rules={[{ required: true, message: "请输入您的姓名" }]}
          >
            <Input placeholder="请输入" size="large" />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">您所在高校名称</span>}
            name="school"
            rules={[{ required: true, message: "请输入您所在高校名称" }]}
          >
            <Input placeholder="请输入" size="large" />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">您的专业</span>}
            name="professional"
            rules={[{ required: true, message: "请输入您的专业" }]}
          >
            <Input placeholder="请输入" size="large" />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">您的年级</span>}
            name="grade"
            rules={[{ required: true, message: "请选择您的年级" }]}
            style={{ display:'inline-block', width: gradeOther ? '30%' : '100%', marginRight: '10px' }}
          >
            <Select
              placeholder="请选择"
              size="large"
              onChange={(value) => {
                setGradeOther(value === "其他");
                if (value !== "其他") {
                  form.setFieldsValue({ grade_other: undefined });
                }
              }}
            >
              <Option value="大三">大三</Option>
              <Option value="大四">大四</Option>
              <Option value="研一">研一</Option>
              <Option value="研二">研二</Option>
              <Option value="研三">研三</Option>
              <Option value="博士">博士</Option>
              <Option value="其他">其他</Option>
            </Select>
          </Form.Item>
          
          {gradeOther && (
            <Form.Item label=" " name="grade_other" style={{ display:'inline-block', width: '60%' }}
            rules={[
              { required: true, message: "请在此输入具体内容" }
            ]}
            >
              <Input placeholder="请输入具体内容" size="large" maxLength={10} />
            </Form.Item>
          )}
          
          <Form.Item
            label={<span className="required-label">请输入您的手机号码</span>}
            name="mobile"
            rules={[
              { required: true, message: "请输入您的手机号码" },
              { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码" },
            ]}
          >
            <Input placeholder="请输入" size="large" maxLength={11} />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">请输入您的微信号</span>}
            name="wechat"
            rules={[
              { required: true, message: "请输入您的微信号" }
            ]}
          >
            <Input placeholder="请输入" size="large" />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">请输入您的邮箱</span>}
            name="email"
            rules={[
              { required: true, message: "请输入您的邮箱" },
              { type: "email", message: "请输入正确的邮箱地址" },
            ]}
          >
            <Input placeholder="请输入" size="large" />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">附件上传：简历(可包含GitHub链接、个人网页等)/成绩单/论文/项目作品集/竞赛奖项证明等，文件命名注明材料名称</span>}
            required
            rules={[
              {
                validator: () => {
                  if (fileList.length === 0) {
                    return Promise.reject(new Error("请至少上传一个附件"));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Upload
              fileList={fileList}
              beforeUpload={beforeUpload}
              onChange={handleFileChange}
              onRemove={handleRemove}
              multiple
              maxCount={10}
              showUploadList={{
                showRemoveIcon: true,
                showPreviewIcon: true,
              }}
            >
              <Button icon={<UploadOutlined />} size="large" style={{ fontSize: '14px' }}>
                点击上传文件
              </Button>
            </Upload>
            <p className="upload-tips">
              最多10个,单个文件大小不超过30MB,不限制文件格式
            </p>
          </Form.Item>

          <Form.Item className="submit-item">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={uploading}
              className="submit-button"
            >
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default withRouter(QuestionnaireSurvey);
